<template >
    <div v-if="visible">
        <!-- 启用、停用二次弹窗 -->
        <el-dialog
            :visible.sync="visible"
            title="提示"
            :width="'824px'"
            :before-close="cancelHandle"
            @open="handleInitial"
          >
              <div v-if="confirmDialog.type === ENUM.STATE_ENUM.disable">
                确定启用“{{ confirmDialog.merchantName }}”的子户配置？</div>
              <div v-else-if="confirmDialog.type === ENUM.STATE_ENUM.enable">
                已关联的公司将无法看到该子账户,且该公司所有租赁订单都无法使用线上支付的维保项目
              </div>
              <template slot="footer">
                  <el-button size="small" @click="visible = false">取消</el-button>
                  <el-button
                      size="small"
                      :loading="confirmDialog.loading"
                      type="primary"
                      @click="submitConfirmHandle"
                  >确认</el-button>
              </template>
        </el-dialog>
    </div>
</template>

<script>
import config from '../config'
import { modifySubAccountState } from '@/api/domain/finance'

export default {
  name: 'EnableAnddisableDialog',
  data() {
    const { ENUM } = config.call(this)
    return {
      visible: false,
      ENUM,
      confirmDialog: {
        loading: false,
        type: '',
        merchantName: '',
        accountId: '',
      },
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    open(confirmDialog) {
      this.confirmDialog = confirmDialog
      this.visible = true
    },
    cancelHandle() {
      this.visible = false
    },
    handleInitial() {},
    async submitConfirmHandle() {
      this.confirmDialog.loading = true
      try {
        const { code, data } = await modifySubAccountState({
          accountId: this.confirmDialog.accountId,
          accountType: 2,
          state: this.confirmDialog.type === this.ENUM.STATE_ENUM.enable ?
            this.ENUM.STATE_ENUM.disable : this.ENUM.STATE_ENUM.enable,
        })
        if (code === 1) {
          if (data.result) {
            this.$message.success(
              `${this.confirmDialog.type === this.ENUM.STATE_ENUM.enable ? '停用' : '启用'}成功`,
            )
            this.$emit('update')
            this.cancelHandle()
          } else {
            this.$message.error(data.info)
          }
        }
        this.confirmDialog.loading = false
      } catch (error) {
        this.confirmDialog.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
